/* eslint-disable implicit-arrow-linebreak */
// =============================
// Imports
// =============================

import {
  composeValidators,
  minLength,
  mustBeComplexPassword,
  mustBeEmail,
  mustBeEqualTo,
  required,
} from '../index';

// =============================
// Validator
// =============================

const validator = {
  first_name: required,
  last_name: required,
  email: composeValidators(required, mustBeEmail),
  phone_number: required,
  company_name: required,
  job: required,
  country: required,
  company_type: required,
  password: composeValidators(required, minLength(8), mustBeComplexPassword),
  password_confirmation: (compareVal, fieldName) => composeValidators(
    required,
    minLength(8),
    mustBeComplexPassword,
    mustBeEqualTo(compareVal, fieldName),
  ),
};

export default validator;
